import * as actionType from "../types/ActionTypes";

const initialState = {
  weekDays: [],
  postWeekDays: [],
  error: false,
  isLoading: false,
  isPostLoading: false,
  isUpdateLoading: false,
};

export const WeekDays = (state = initialState, action) => {
  switch (action.type) {
    case actionType.WEEK_DAYS_SET_DATA:
      return {
        ...state,
        weekDays: action.weekDays,
        error: false,
        isLoading: false,
        isPostLoading: false,
        isUpdateLoading: false,
      };

    case actionType.WEEK_DAYS_FAIL_DATA:
      return {
        ...state,
        error: action.error,
        isLoading: false,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.WEEK_DAYS_LOADING:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case actionType.WEEK_DAYS_POST_LOADING:
      return {
        ...state,
        isPostLoading: true,
        error: false,
      };
    case actionType.WEEK_DAYS_UPDATE_LOADING:
      return {
        ...state,
        isUpdateLoading: true,
        error: false,
      };
    case actionType.POST_WEEK_DAYS_DATA_FAIL:
      return {
        ...state,
        error: action.error,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.POST_WEEK_DAYS_DATA_SUCCESS:
      return {
        ...state,
        isPostLoading: false,
        error: false,
        postWeekDays: action.postWeekDays,
      };
    case actionType.UPDATE_WEEK_DAYS_DATA_FAIL:
      return {
        ...state,
        error: action.error,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.UPDATE_WEEK_DAYS_DATA_SUCCESS:
      return {
        ...state,
        isPostLoading: false,
        error: false,
        isUpdateLoading: false,
      };
    case actionType.UPDATE_WEEK_DAYS_DATA_START:
      return {
        ...state,
      };

    default:
      return state;
  }
};
